import React, { useEffect } from 'react';
import { useInput } from 'configurable-form/components/utils/use-input';
import { renderFieldComponent } from 'configurable-form';
import {
  FormikError,
  ReverseArgumentInput,
} from 'configurable-form/components/inputs/shared-components';

import { withVisibility } from 'configurable-form/components/utils/with-visibility';


function UnitNumberComponent(props) {
  const {
    /**
     * There will always be components here to render.
     * In the case where no components are defined, then the TS builder will insert a singular "PageHeader"
     *  component as we don't want this unit number input field to not be able while displayed on the screen.
     */
    preFieldComponents,
    postFieldComponents = [],
    serverHasMatchedAProperty,
  } = props;

  // "unitNumber" is hardcoded purposefully
  const { field, meta, helpers } = useInput({ name: 'unitNumber', validation: props.validation });

  useEffect(() => {
    if (!serverHasMatchedAProperty && field.value) helpers.setValue(undefined);
  }, [field.value, helpers, serverHasMatchedAProperty]);

  if (!serverHasMatchedAProperty) return null;

  return (
    <div>
      {preFieldComponents.map((c, i) => renderFieldComponent(c, `preUnitNumberFieldComponents${i}`))}

      <ReverseArgumentInput {...field} value={field.value || ''} autoComplete="off" />
      <FormikError {...meta} />

      {postFieldComponents.map((c, i) => renderFieldComponent(c, `postUnitNumberFieldComponents${i}`))}
    </div>
  );
}

export const UnitNumber = withVisibility(UnitNumberComponent);
